import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink';

import { ParametersFacade } from '@facades/parameters.facade';

@Component({
	selector: 'app-whatsapp-button',
	templateUrl: './whatsapp-button.component.html',
	styleUrls: ['./whatsapp-button.component.scss'],
})
export class WhatsAppButtonComponent implements OnInit, OnDestroy {
	private subs = new SubSink();

	constructor(private parametersFacade: ParametersFacade) {}

	get linkWhats() {
		return this.telWhatsapp ? `https://wa.me/55${this.telWhatsapp}` : '';
	}

	ngOnInit(): void {}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	get telWhatsapp() {
		return this.parametersFacade.parameters?.telWhatsapp?.replace(
			/[^0-9]/g,
			''
		);
	}

	openWhats() {
		return window.open(this.linkWhats, '_blank');
	}
}
